import { Entity } from '@backstage/catalog-model';
import { MissingAnnotationEmptyState } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { detailRouteRef } from '../../routes';
import { ForensicsTable } from '../ForensicsTable';
import { DetailedView } from '../DetailedView';

/** @public */
export const isForensicsAvailable = (entity: Entity) =>
  entity.metadata.tags?.includes('otk') || false;

export const Router = () => {
  const { entity } = useEntity();

  if (!isForensicsAvailable(entity)) {
    return <MissingAnnotationEmptyState annotation='otk' />;
  }

  return (
    <Routes>
      <Route path="/" element={<ForensicsTable />} />
      <Route path={`/${detailRouteRef.path}`} element={<DetailedView />} />
    </Routes>
  );
};
